var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex min-h-5 mb-1"},[_c('span',{staticClass:"text-red-600 text-sm"},[_vm._v(_vm._s(_vm.errMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }